import { render, staticRenderFns } from "./MStep1.vue?vue&type=template&id=67ed7be4&scoped=true"
import script from "./MStep1.vue?vue&type=script&lang=js"
export * from "./MStep1.vue?vue&type=script&lang=js"
import style0 from "./MStep1.vue?vue&type=style&index=0&id=67ed7be4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed7be4",
  null
  
)

export default component.exports